import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import clsx from 'clsx';
import styles from './OTooltip.module.scss';

interface OTooltipProps extends TooltipProps {
  isCapitalized?: boolean;
  customStyles?: {
    tooltip?: React.CSSProperties;
    arrow?: React.CSSProperties;
  };
  isSmall?: boolean;
  backgroundColor?: string;
  placement?: 'top' | 'bottom' | 'right' | 'left';
}

const OTooltip = ({
  isCapitalized = false,
  isSmall = false,
  backgroundColor = 'var(--icon-bg)',
  customStyles = {},
  placement = 'bottom',
  className,
  slotProps,
  ...props
}: OTooltipProps) => {
  return (
    <Tooltip
      {...props}
      placement={placement}
      arrow
      classes={{
        popper: clsx(className, styles.tooltipPopper),
        tooltip: clsx(styles.tooltip, isCapitalized && styles.capitalized, isSmall && styles.small),
      }}
      slotProps={{
        ...slotProps,
        tooltip: {
          ...slotProps?.tooltip,
          style: {
            backgroundColor,
            ...customStyles?.tooltip,
          },
        },
        arrow: {
          ...slotProps?.arrow,
          style: {
            color: backgroundColor,
            ...customStyles?.arrow,
          },
        },
      }}
    />
  );
};

export default OTooltip;
